import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { actionsUser } from '@constants/actions.constants';
import { ContentDelegadosDesignadosI } from '@modulos/delegados/delegados-designados/delegados-designados.interface';
import { ContentBarriosI } from 'app/modulos/reer/barrios/barrios.interface';

/**
 * La convencion para armar este diccionario es la siguiente: key = Componente__accion , value = componente__accion o nombreDelArchivo__accion
 */
export enum SpecialValidationsDictionary {
  Barrios__Edit = 'barrios-component__edit',
  Barrios__Delete = 'barrios-component__delete',
  Delegados_Designados_List = 'delegados-designados.component',
}
/**
 * Una vez se agrega algun elemento al diccionario ? Debe agregarse acá como un tipo más
 */
export type SpecialValidations = SpecialValidationsDictionary.Barrios__Edit | SpecialValidationsDictionary.Barrios__Delete | SpecialValidationsDictionary.Delegados_Designados_List;

@Directive({
  selector: '[permissions]',
  standalone: true,
})
export class RequestForPermissionsDirective<T> {
  /**
   * Corresponde al array de permisos que tiene el usuario, esto es recibido por medio de una consulta hecha por su componente padre
   */

  @Input({ required: true }) permissions: string[] = [];
  /**
   * Corresponde al permiso con que cuenta el usuario para una determinada pantalla
   */

  @Input({ required: true }) permissionGranted: string = '';
  /**
   * Se utiliza para configurar el comportamiento, teniendo en cuenta: 1 ) Si requireSpecialValidations === false significa que no se requieren validaciones especiales, 2)  Si requireSpecialValidations !== false debemos recibir un elemento existente en SpecialValidationsDictionary
   */
  @Input({ required: true }) requireSpecialValidations: false | SpecialValidations = false;

  /**
   * Es la data que se pase como parametro en caso de utilizarse sobre filas o sobre algun elemento en particular. No es requerido porque esta validacion es usada para botones ajenos a la Grilla Generica y por ende es posible que este valor no exista, por ende, se contempla este caso mas abajo en la logica
   */
  @Input() data!: T;

  ngOnInit(): void {
    const isAvailable = this.permissions.includes(this.permissionGranted);
    if (this.permissions?.length < 1 || !this.permissionGranted) {
      this.viewContainer.clear();
      return;
    }

    /**
     * Se "hardcodea" este permiso por los siguientes motivos: 1) Para que los elementos de la grilla trabajen bajo la misma convención, 2) Para no hacer modificaciones al Backend y mantener los permisos que ya se tienen( ahora no es necesario este permiso pero en un futuro puede que lo sea )
     */
    if (this.permissionGranted === actionsUser.DETALLE) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    let specialPermissionsState = true;
    // En caso de que se requieran permisos especiales, llamamos al metodo que corresponda para eso
    // if( this.requireSpecialValidations ) {
    //   specialPermissionsState = this.handleSpecialValidation( this.requireSpecialValidations )
    // }
    if (this.requireSpecialValidations) {
      specialPermissionsState = this.handleSpecialValidation(this.requireSpecialValidations);
    } else {
      this.viewContainer.clear();
    }

    // El elemento se mostrará SI O SI al cumplir: 1) Con permisos de usuario , 2 ) Con las validaciones especiales
    if (isAvailable && specialPermissionsState) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
  constructor(
    private readonly templateRef: TemplateRef<T>,
    private readonly viewContainer: ViewContainerRef,
  ) {}

  /**
   * Metodo auxiliar para gestionar las validaciones que se vayan creando segun su tipo correspondiente en el Diccionario
   * @param type => Se espera que el tipo recibido acá sea uno existente en SpecialValidationsDictionary
   * @returns => Resultado de la validación
   */
  private handleSpecialValidation(type: string) {
    let response = false;
    if (type === SpecialValidationsDictionary.Barrios__Edit) {
      const row = this.data as unknown as ContentBarriosI;
      response = !row.nombreBarrio.includes('A');
    } else if (type === SpecialValidationsDictionary.Barrios__Delete) {
      const row = this.data as unknown as ContentBarriosI;
      response = !row.nombreBarrio.includes('O');
    } else if (type === SpecialValidationsDictionary.Delegados_Designados_List) {
      const row = this.data as unknown as ContentDelegadosDesignadosI;
      response = `${row.state}`.trim().toLowerCase() !== 'excusado';
    }

    return response;
  }
}
